var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1688_3725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7494 2.87451H13.4161C12.9079 2.87451 12.4205 3.07638 12.0612 3.43571C11.7019 3.79504 11.5 4.2824 11.5 4.79057V12.9365L28.7494 22.9985L37.3741 26.6379L45.9988 22.9985V12.9365L28.7494 2.87451Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.9375H28.7494V22.9995H11.5V12.9375Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0828 2.87451H28.7495V12.9365H45.9989V4.79057C45.9989 4.2824 45.797 3.79504 45.4377 3.43571C45.0784 3.07638 44.591 2.87451 44.0828 2.87451Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7494 22.9995H11.5V41.2084C11.5 41.46 11.5496 41.7092 11.6459 41.9416C11.7421 42.1741 11.8833 42.3853 12.0612 42.5632C12.2391 42.7412 12.4503 42.8823 12.6828 42.9786C12.9153 43.0749 13.1644 43.1245 13.4161 43.1245H44.0837C44.3353 43.1245 44.5845 43.0749 44.8169 42.9786C45.0494 42.8823 45.2606 42.7412 45.4386 42.5632C45.6165 42.3853 45.7576 42.1741 45.8539 41.9416C45.9502 41.7092 45.9998 41.46 45.9998 41.2084V33.0615L28.7494 22.9995Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7495 22.9995H45.9989V33.0615H28.7495V22.9995Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.9558 10.062H11.5V37.3744H23.9558C24.4637 37.3736 24.9506 37.1718 25.3102 36.8132C25.6698 36.4545 25.8728 35.9681 25.8748 35.4602V11.9781C25.8733 11.4699 25.6705 10.983 25.3109 10.6239C24.9513 10.2648 24.464 10.0628 23.9558 10.062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5215 11.5H11.5V38.8123H22.5215C23.0288 38.8108 23.515 38.6087 23.8739 38.2501C24.2329 37.8916 24.4355 37.4056 24.4375 36.8982V13.4161C24.436 12.9084 24.2336 12.4219 23.8746 12.0629C23.5156 11.7039 23.0292 11.5015 22.5215 11.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5215 11.5H11.5V35.9368H22.5215C23.0292 35.9353 23.5156 35.7329 23.8746 35.3739C24.2336 35.0149 24.436 34.5284 24.4375 34.0207V13.4161C24.436 12.9084 24.2336 12.4219 23.8746 12.0629C23.5156 11.7039 23.0292 11.5015 22.5215 11.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.0842 11.5H11.5V35.9368H21.0842C21.5919 35.9353 22.0783 35.7329 22.4373 35.3739C22.7963 35.0149 22.9987 34.5284 23.0002 34.0207V13.4161C22.9987 12.9084 22.7963 12.4219 22.4373 12.0629C22.0783 11.7039 21.5919 11.5015 21.0842 11.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.91606 11.5H21.0864C21.5945 11.5 22.0819 11.7019 22.4412 12.0612C22.8006 12.4205 23.0024 12.9079 23.0024 13.4161V32.5864C23.0024 33.0945 22.8006 33.5819 22.4412 33.9412C22.0819 34.3006 21.5945 34.5024 21.0864 34.5024H1.91606C1.66419 34.5024 1.4148 34.4528 1.18214 34.3563C0.949485 34.2598 0.73813 34.1184 0.56017 33.9402C0.382209 33.762 0.241134 33.5504 0.145015 33.3176C0.0488956 33.0848 -0.000381523 32.8353 2.22418e-06 32.5835V13.4161C2.22418e-06 12.9079 0.201872 12.4205 0.561203 12.0612C0.920533 11.7019 1.40789 11.5 1.91606 11.5Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07861 30.1868L9.73009 22.979L5.4698 15.812H8.89808L11.2238 20.3934C11.4373 20.8274 11.5845 21.1518 11.6656 21.3665H11.6958C11.8489 21.0195 12.0094 20.6821 12.1775 20.3545L14.6628 15.812H17.8098L13.4396 22.9391L17.9159 30.1868H14.5704L11.8836 25.1539C11.7572 24.9397 11.65 24.7146 11.5634 24.4815H11.5235C11.4451 24.7096 11.341 24.928 11.2131 25.1325L8.45239 30.1868H5.07861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1688_3725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftExcel);
export default __webpack_public_path__ + "static/media/microsoft-excel.6d3443c51edae9e1ac1a8e396641ca3a.svg";
export { ForwardRef as ReactComponent };